import { ComponentType } from 'react';
import { LazyRouteFunction, RouteObject } from 'react-router';

type PageImporter = () => Promise<Record<string, ComponentType>>;

const page =
  (importer: PageImporter, exportName: string): LazyRouteFunction<RouteObject> =>
  async () => ({ Component: (await importer())[exportName] });

export { page };
export type { PageImporter };
